import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollAPDFileExport  {
    _originalTypeClassName = "zERP.BO.PayrollAPDFileExport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollAPDFileExport.translate = translateService;
}
this.Details = [];
this.PayrollCalculations = [];
this.Id = null;
this.Name = null;
this.DateFrom = null;
this.DateTo = null;
this.Status = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
DateFrom:any;
DateTo:any;
Status:any;
Details:any;
PayrollCalculations:any;
static setDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.Details == null) $this.Details = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Details.length > 0) {
                    Domain.PayrollAPDFileExport.removeDetails($this, $this.Details[0]);
                }

                Domain.PayrollAPDFileExport.addManyDetails($this, copyItems);
            }
static addManyDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollAPDFileExport.addDetails($this, items[i]);
                }
            }
static addDetails = ($this, item) => {
                if ($this.Details == null) $this.Details = [];
                if (item == null || $this.Details.indexOf(item) > -1) return;
                $this.Details.push(item);
if (item.PayrollAPDFileExport != $this) {
Domain.PayrollAPDFileExportDetail.setPayrollAPDFileExport(item, $this);
}
}
static addRangeDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollAPDFileExport.addDetails($this, item));
            }
static removeDetails = ($this, item) => {
                if ($this == null || $this.Details == null || $this.Details.indexOf(item) === -1) return;
                var _index = $this.Details.indexOf(item);
                $this.Details.splice(_index, 1);
item.PayrollAPDFileExport = null;
}
static clearDetails = ($this) => { $this.Details = null; }
static setPayrollCalculations = ($this, items) => {
                if (items == null) items = [];
                if ($this.PayrollCalculations == null) $this.PayrollCalculations = [];

                const copyItems = Common.cloneObject(items);

                while ($this.PayrollCalculations.length > 0) {
                    Domain.PayrollAPDFileExport.removePayrollCalculations($this, $this.PayrollCalculations[0]);
                }

                Domain.PayrollAPDFileExport.addManyPayrollCalculations($this, copyItems);
            }
static addManyPayrollCalculations = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollAPDFileExport.addPayrollCalculations($this, items[i]);
                }
            }
static addPayrollCalculations = ($this, item) => {
                if ($this.PayrollCalculations == null) $this.PayrollCalculations = [];
                if (item == null || $this.PayrollCalculations.indexOf(item) > -1) return;
                $this.PayrollCalculations.push(item);
if (item.APDFileExport != $this) {
Domain.PayrollCalculation.setAPDFileExport(item, $this);
}
}
static addRangePayrollCalculations = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollAPDFileExport.addPayrollCalculations($this, item));
            }
static removePayrollCalculations = ($this, item) => {
                if ($this == null || $this.PayrollCalculations == null || $this.PayrollCalculations.indexOf(item) === -1) return;
                var _index = $this.PayrollCalculations.indexOf(item);
                $this.PayrollCalculations.splice(_index, 1);
item.APDFileExport = null;
}
static clearPayrollCalculations = ($this) => { $this.PayrollCalculations = null; }

static FetchPayrollsForPeriod($this: any): any{}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}